import { useEffect, useState } from "react";
import { Star } from "lucide-react";
import api from "@/lib/api";
import { triggerLink } from "@/lib/actions";
import { SectionHeading } from "@/components/common/SectionHeading";
import { Reveal } from "@/components/common/Reveal";

export const ReviewsSection = () => {
  const [data, setData] = useState({ summary: null, items: [] });
  useEffect(() => {
    api.get("/reviews").then((r) => setData(r.data)).catch(() => {});
  }, []);

  return (
    <section className="py-16 lg:py-24 bg-white" data-testid="google-reviews-module">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHeading
          eyebrow="What Patients Say"
          title="Trusted by families across India and beyond"
          subtitle={data.summary ? `${data.summary.average} average rating from ${data.summary.count}+ Google reviews` : ""}
        />
        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6">
          {data.items.slice(0, 6).map((r, i) => (
            <Reveal key={i} delay={(i % 3) * 0.06}>
              <div className="h-full rounded-[var(--cdt-radius-md)] bg-[var(--cdt-surface-2)] border border-[color:var(--cdt-border)] p-6">
                <div className="flex gap-0.5">
                  {Array.from({ length: r.rating }).map((_, k) => (
                    <Star key={k} className="h-4 w-4 fill-[var(--cdt-accent)] text-[var(--cdt-accent)]" />
                  ))}
                </div>
                <p className="mt-3 text-sm leading-7 text-[var(--cdt-text)]">“{r.text}”</p>
                <p className="mt-4 text-sm font-semibold text-[var(--cdt-primary-2)]">{r.author}</p>
              </div>
            </Reveal>
          ))}
        </div>
        {data.summary?.google_url && (
          <div className="mt-8 text-center">
            <button onClick={() => triggerLink(data.summary.google_url, true)} data-testid="reviews-google-link" className="text-sm font-semibold text-[var(--cdt-primary)] underline underline-offset-4">
              Read more reviews on Google
            </button>
          </div>
        )}
      </div>
    </section>
  );
};
